var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiningRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 255,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-424 -310)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M622.414 370.153 599.554 370.153 577.363 347.962 552 360.641 520.298 354.302 507.616 370.153 481.586 370.153 459.396 395.656 644.604 395.667 622.414 370.153Z",
    fill: "#AB0520",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.062 506.792 601.522 506.792C606.637 500.592 605.757 491.42 599.558 486.306 593.359 481.191 584.187 482.071 579.072 488.27 574.636 493.647 574.636 501.415 579.072 506.792L522.216 506.792C527.33 500.592 526.449 491.42 520.249 486.306 514.049 481.192 504.877 482.073 499.763 488.273 495.329 493.65 495.329 501.415 499.763 506.792L430.292 506.792 430.292 517.375 443.521 517.375 443.521 525.312 467.333 525.312 467.333 517.375 491.146 517.375 491.146 525.312 514.958 525.312 514.958 517.375 538.771 517.375 538.771 525.312 562.583 525.312 562.583 517.375 586.396 517.375 586.396 525.312 610.208 525.312 610.208 517.375 634.021 517.375 634.021 525.312 657.833 525.312 657.833 517.375 671.062 517.375Z",
    fill: "#AB0520",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.904 496.208 488.566 496.208C489.278 483.824 499.895 474.362 512.279 475.074 523.669 475.729 532.758 484.819 533.413 496.208L567.875 496.208C568.6 483.825 579.226 474.374 591.609 475.099 602.981 475.764 612.054 484.837 612.719 496.208L617.384 496.208 647.462 424.771 655.188 424.771 655.188 406.25 446.167 406.25 446.167 424.771 453.84 424.771Z",
    fill: "#AB0520",
    fillRule: "nonzero",
    fillOpacity: 1
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiningRed);
export default __webpack_public_path__ + "static/media/mining_red.1e43736ba7b59f55a9ee7bdb3777b043.svg";
export { ForwardRef as ReactComponent };